// external imports
import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';

// custom hooks & context
import { pipelineContext } from '../../contexts/pipelineContext';

const Navlink = ({
	path,
	icon,
	text,
	navlinkProps
}) => {
	const { resetState } = useContext(pipelineContext);
	const {userQCing, userUploading, setUserUploading, navIsOpen} = navlinkProps

	if (userUploading) {
		// sets user uploading to false when clicked

		return (
			<NavLink
				to={path}
				className={({ isActive }) =>
					isActive ? 'nav-link navHover' : 'nav-link text-white'
				}
				onClick={() => setUserUploading(false)}
				title={navIsOpen ? '' : text}
			>
				<span className={icon}></span>
				{navIsOpen ? text : null}
			</NavLink>
		);
	}

	if (userQCing) {
		// requires user to Exit QC properly (remove caps from queue)

		return (
			<>
				<NavLink
					data-bs-toggle="modal"
					data-bs-target="#exitQCModal"
					to={path}
					className={({ isActive }) =>
						isActive ? 'nav-link navHover' : 'nav-link text-white'
					}
					title={navIsOpen ? '' : text}
				>
					<span className={icon}></span>
					{navIsOpen ? text : null}
				</NavLink>
			</>
		);
	} else {
		// return normal nav link

		return (
			<NavLink
				to={path}
				onClick={() => resetState()}
				className={({ isActive }) =>
					isActive ? 'nav-link navHover' : 'nav-link text-white'
				}
				title={navIsOpen ? '' : text}
			>
				<span className={icon}></span>
				{navIsOpen ? text : null}
			</NavLink>
		);
	}
};

export default Navlink;
